import { Badge, Box } from '@mui/material';
import React, { CSSProperties } from 'react';

interface Props {
  image: string | null | undefined;
  badge?: boolean;
  /** Reads as "needs attention" rather than "unread" */
  needsAttention?: boolean;
  width?: CSSProperties['width'];
}

function TableImage({ image, badge, needsAttention, width = '75px' }: Props) {
  const [isError, setIsError] = React.useState(false);

  React.useEffect(() => {
    setIsError(false);
  }, [image]);

  return (
    <Box
      position="relative"
      maxWidth={width}
      height={{
        xs: width,
        md: 'auto',
      }}
      minHeight={width}>
      <Badge
        invisible={!badge && !needsAttention}
        color="primary"
        variant={needsAttention ? 'standard' : 'dot'}
        badgeContent={needsAttention ? '!' : undefined}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          width: '100%',
          height: '100%',
          aspectRatio: '1/1',
          '.MuiBadge-badge': {
            minWidth: needsAttention ? 16 : 10,
            height: needsAttention ? 16 : 10,
            padding: 0,
            borderRadius: '50%',
            typography: 'overline',
          },
        }}>
        <img
          src={isError || !image ? '/no-pictures.png' : image}
          alt="Tattoo inspiration"
          style={{
            objectFit: 'cover',
            width: '100%',
          }}
          onError={() => setIsError(true)}
        />
      </Badge>
    </Box>
  );
}

export default TableImage;
